import {Col, Row} from "antd";
import {StoreServiceDeliveryTimeFrameFormFieldProps} from "./types";
import {ServiceDeliveryTimeFrameUnitFormField} from "./time-frame-unit";
import {ServiceDeliveryTimeFrameValueFormField} from "./time-frame-value-form-field";

export function ServiceDeliveryTimeframeFormFields({
  deliveryTimeFrameUnitFormFieldId,
  deliveryTimeFrameUnitFormFieldLabel,
  deliveryTimeFrameUnitFormFieldPlaceholder,
  deliveryTimeFrameValueFormFieldId,
  deliveryTimeFrameValueFormFieldLabel,
  deliveryTimeFrameValueFormFieldPlaceholder,
}: StoreServiceDeliveryTimeFrameFormFieldProps) {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24} sm={12}>
        <ServiceDeliveryTimeFrameValueFormField
          id={deliveryTimeFrameValueFormFieldId}
          label={deliveryTimeFrameValueFormFieldLabel}
          placeholder={deliveryTimeFrameValueFormFieldPlaceholder}
        />
      </Col>
      <Col span={24} sm={12}>
        <ServiceDeliveryTimeFrameUnitFormField
          id={deliveryTimeFrameUnitFormFieldId}
          label={deliveryTimeFrameUnitFormFieldLabel}
          placeholder={deliveryTimeFrameUnitFormFieldPlaceholder}
        />
      </Col>
    </Row>
  );
}
